var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy"},[_c('div',{attrs:{"name":"termly-embed","data-id":"152235ab-68f9-4d0b-ade6-e771fb6237a1","data-type":"iframe"}})])
}]

export { render, staticRenderFns }